import { keyBy, orderBy, sortBy } from 'lodash-es';
import { getContactMapStatus } from './getContactMapStatus';
export const CREATE_NEW_VALUE = '__create_new__';
export function getModalState(param) {
    let { contacts, contactsLoading, contactsError, accountingCustomersLoading, accountingCustomersError } = param;
    if (contactsError || accountingCustomersError) {
        return {
            content: 'error'
        };
    }
    if (contactsLoading || accountingCustomersLoading) {
        return {
            content: 'loading'
        };
    }
    if (contacts.length === 0) {
        return {
            content: 'empty'
        };
    }
    return {
        content: 'valid'
    };
}
export function getNumMappedContacts(contacts, accounting, accountingCustomers) {
    if (!accountingCustomers) {
        return 0;
    }
    return contacts.filter((c)=>getContactMapStatus(c, accounting, accountingCustomers) === 'mapped').length;
}
export function getRelevantSortedContacts(contacts, contactIds, accounting) {
    if (!contacts) {
        return [];
    }
    const filtered = contacts.filter((c)=>(!contactIds.length || contactIds.includes(c.id())) && !c.isSample());
    const orderedByName = orderBy(filtered, [
        (c)=>c.firstName(),
        (c)=>c.lastName(),
        (c)=>c.companyName()
    ], [
        'asc',
        'asc',
        'asc'
    ]);
    return sortBy(orderedByName, (c)=>!!c.integratedId({
            accounting
        }));
}
export function buildContactRows(param) {
    let { contacts, accounting, accountingCustomers } = param;
    const dictionary = keyBy(accountingCustomers, (c)=>c.id());
    return contacts.map((contact)=>{
        const integratedId = contact.integratedId({
            accounting
        });
        const mappedCustomer = integratedId ? dictionary[integratedId] : undefined;
        const mapStatus = getContactMapStatus(contact, accounting, accountingCustomers);
        const [anchor, anchorSubtitle] = getContactLines(contact);
        return {
            id: contact.id(),
            anchor,
            anchorSubtitle,
            mapping: mappedCustomer && integratedId ? integratedId : '',
            status: mapStatus === 'mapped' ? 'mapped' : mapStatus === 'failedToMap' ? 'failedToMap' : 'notMapped'
        };
    });
}
function getContactLines(contact) {
    const fullName = [
        contact.firstName(),
        contact.lastName()
    ].filter(Boolean).join(' ');
    const email = contact.email();
    const nameWithEmail = [
        fullName,
        email ? "(".concat(email, ")") : ''
    ].filter(Boolean).join(' ');
    return [
        nameWithEmail,
        [
            contact.companyName()
        ]
    ];
}
